"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionStoreRedux = void 0;
const storage_adapter_1 = require("./storage-adapter");
class SessionStoreRedux {
    constructor(storeName) {
        this.storage = new storage_adapter_1.default(storeName, storage_adapter_1.default.types.SESSION_STORAGE);
    }
    saveSessionState(state) {
        const { financing } = state;
        this.storage.writeEntry({ financing });
    }
    getSessionState() {
        return this.storage.readEntry();
    }
}
exports.SessionStoreRedux = SessionStoreRedux;
//# sourceMappingURL=sessionStoreRedux.js.map